export const mobileTemplate = '1fr 1fr';
export const titles = ['Product', 'PRP', 'Sold', 'Remaining', 'Total'];
export const cellsMobile = [
  { row: '1/2', col: '1/3' },
  { row: '2/3', col: '1/2' },
  { row: '2/3', col: '2/3' },
];
